import { useState } from "react";
import { NavLink } from "react-router-dom";

import { ContentWrapper, PaddingConfig } from "components/ContentWrapper";
import { Accordion } from "components/Accordion/Accordion";

import styles from "./styles.module.scss";
import { MENU_CONFIG } from "./utils";
import { MenuItem } from "./MenuItem";

const MENU_PADDING_CONFIG: PaddingConfig = {
  paddingTop: 40,
  paddingBottom: 16,
  paddingLeft: 32,
  paddingRight: 32,
};

type NavLinkRenderProps = {
  isActive: boolean;
  isPending: boolean;
  isTransitioning: boolean;
};

interface Sections {
  ["Справочники"]: boolean;
  ["Документы"]: boolean;
  [name: string]: boolean;
}

export const Menu = (): JSX.Element => {
  const [collapse, setCollapse] = useState<Sections>({
    ["Справочники"]: false,
    ["Документы"]: false,
  });

  const onChangeCollapse = (name: keyof Sections | string) => {
    setCollapse((prevState) => ({
      ...prevState,
      [name]: !prevState[name],
    }));
  };

  const getClassnames = (
    props: NavLinkRenderProps,
    parent?: boolean
  ): string => {
    const { isActive } = props;

    if (parent) {
      return [isActive ? "menuCategoryActive" : ""].join(" ");
    }
    return [isActive ? "menuItemActive" : ""].join(" ");
  };

  return (
    <div className={styles.menu}>
      <ContentWrapper paddingConfig={MENU_PADDING_CONFIG}>
        {MENU_CONFIG.map(({ name, ...menuItem }) => {
          if (typeof menuItem.children !== "undefined") {
            return (
              <Accordion
                withIcon
                key={name}
                collapsed={collapse[name]}
                parent={
                  <MenuItem
                    isActive={!collapse[name]}
                    icon={menuItem.icon}
                    name={name}
                    onClick={() => onChangeCollapse(name)}
                  />
                }
              >
                {menuItem.children.map((child) => (
                  <NavLink
                    key={child.name}
                    to={child.path}
                    className={getClassnames}
                  >
                    <MenuItem icon={child.icon} name={child.name} />
                  </NavLink>
                ))}
              </Accordion>
            );
          }
          return (
            <NavLink key={name} to={menuItem.path}>
              <MenuItem icon={menuItem.icon} name={name} />
            </NavLink>
          );
        })}
      </ContentWrapper>
    </div>
  );
};
